module.exports = __webpack_public_path__ + "static/img/wx-weapp.af314752.png";